import templateUrl from "emun.order/order-details-change-notices.htm";

export default () => ({ templateUrl });
